module.exports = __webpack_public_path__ + "static/media/intropart3.c291c76a.png";